















































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import VColumnSelect from '@/components/shared/table/VColumnSelect.vue';
import articleHeaders from './headers';
import { ColumnHeader } from '@/interfaces/components/ColumnHeader';
import VTable from '@/components/shared/table/VTable.vue';
import { Article } from '@/interfaces/models/Article';
import { Category } from '@/interfaces/models/Category';
import { Permission } from '@/enums/Permission';

@Component({
  components: { VTable, VColumnSelect },
})
export default class ArticleTable extends Vue {
  @Prop({ type: Array, required: true }) public items!: Article[];
  @Prop({ type: Number, required: true }) public total!: number;
  @Prop({ type: Array, required: true }) public categories!: Category[];
  public sourceHeaders = this.accessibleHeaders;
  public headers: ColumnHeader[] = this.accessibleHeaders.filter((c: ColumnHeader) => c.default);

  protected category: string = '';

  public mounted() {
    if (this.$route && this.$route.query && this.$route.query.category) {
      this.category = this.$route.query.category as string;
    }
  }

  get accessibleHeaders() {
    return articleHeaders.filter((c: ColumnHeader) => {
      if (
        c.value === 'isControlArticle' &&
        this.$can(Permission.ARTICLE_CONTROL_ACTIVATE) &&
        this.$can(Permission.ARTICLE_CONTROL_DEACTIVATE)
      ) {
        return true;
      }
      return c.value !== 'isControlArticle';
    });
  }

  public edit(item: Article) {
    if (this.$can(Permission.ARTICLE_UPDATE)) {
      this.$router.push({
        name: 'article.edit',
        params: { id: item._id, category: this.category },
        query: { ...this.$route.query, category: this.category },
      });
    } else {
      this.$router.push({
        name: 'article.editSimple',
        params: { id: item._id, category: this.category },
        query: { ...this.$route.query, category: this.category },
      });
    }
  }

  public canToggleControlArticle(val: boolean) {
    if (val) {
      return this.$can(Permission.ARTICLE_CONTROL_DEACTIVATE);
    }
    return this.$can(Permission.ARTICLE_CONTROL_ACTIVATE);
  }

  public canToggleActivation(val: boolean) {
    if (val) {
      return this.$can(Permission.ARTICLE_DEACTIVATE);
    }
    return this.$can(Permission.ARTICLE_ACTIVATE);
  }

  public canToggleVisbility(val: boolean) {
    if (val) {
      return this.$can(Permission.ARTICLE_VISIBLE);
    }
    return this.$can(Permission.ARTICLE_HIDE);
  }

  @Watch('category')
  @Emit('category')
  public onCategoryChange() {
    if (this.category) {
      return { category: this.category };
    }

    return null;
  }
}
